var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass: "d-flex align-items-center text-center mt-4",
      staticStyle: { "min-height": "350px" },
    },
    [
      _c(
        "div",
        { staticClass: "w-100" },
        [
          _c("v-card-title", { staticClass: "card-title" }, [
            _vm._v(" Datos Personales "),
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { staticClass: "pa-3" },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c("BaseInput", {
                        attrs: {
                          label: "Nro Legajo*",
                          name: "nro_legajo",
                          rules: "required",
                          validationErrors: _vm.errors,
                          loading: _vm.loading_nro_legajo,
                          disabled: _vm.legajo.id > 0,
                        },
                        model: {
                          value: _vm.legajo.nro_legajo,
                          callback: function ($$v) {
                            _vm.$set(_vm.legajo, "nro_legajo", $$v)
                          },
                          expression: "legajo.nro_legajo",
                        },
                      }),
                      _c("BaseCombobox", {
                        attrs: {
                          label: "Género",
                          name: "gender",
                          items: _vm.genders,
                          "item-text": "name",
                          "item-value": "id",
                          loading: _vm.loading_genders,
                          rules: "",
                          validationErrors: _vm.errors,
                        },
                        model: {
                          value: _vm.legajo.gender,
                          callback: function ($$v) {
                            _vm.$set(_vm.legajo, "gender", $$v)
                          },
                          expression: "legajo.gender",
                        },
                      }),
                      _c("BaseDatePicker", {
                        attrs: {
                          label: "Fecha de nacimiento",
                          name: "birthdate",
                          rules: "",
                          validationErrors: _vm.errors,
                        },
                        model: {
                          value: _vm.legajo.birthdate,
                          callback: function ($$v) {
                            _vm.$set(_vm.legajo, "birthdate", $$v)
                          },
                          expression: "legajo.birthdate",
                        },
                      }),
                      _c("BaseCombobox", {
                        attrs: {
                          label: "Nivel de estudio",
                          name: "level_study",
                          items: _vm.level_studies,
                          "item-text": "name",
                          "item-value": "id",
                          loading: _vm.loading_level_studies,
                          rules: "",
                          validationErrors: _vm.errors,
                        },
                        model: {
                          value: _vm.legajo.level_study,
                          callback: function ($$v) {
                            _vm.$set(_vm.legajo, "level_study", $$v)
                          },
                          expression: "legajo.level_study",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c("BaseInput", {
                        attrs: {
                          label: "Nombre*",
                          name: "name",
                          rules: "required",
                          validationErrors: _vm.errors,
                        },
                        model: {
                          value: _vm.legajo.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.legajo, "name", $$v)
                          },
                          expression: "legajo.name",
                        },
                      }),
                      _c("BaseCombobox", {
                        attrs: {
                          label: "Tipo documento*",
                          name: "document_type",
                          items: _vm.doc_types,
                          "item-text": "name",
                          "item-value": "id",
                          loading: _vm.loading_doc_types,
                          rules: "required",
                          validationErrors: _vm.errors,
                        },
                        model: {
                          value: _vm.legajo.document_type,
                          callback: function ($$v) {
                            _vm.$set(_vm.legajo, "document_type", $$v)
                          },
                          expression: "legajo.document_type",
                        },
                      }),
                      _c("BaseInput", {
                        attrs: {
                          label: "Nacionalidad",
                          name: "nationality",
                          rules: "required",
                          validationErrors: _vm.errors,
                        },
                        model: {
                          value: _vm.legajo.nationality,
                          callback: function ($$v) {
                            _vm.$set(_vm.legajo, "nationality", $$v)
                          },
                          expression: "legajo.nationality",
                        },
                      }),
                      _c("BaseInput", {
                        attrs: {
                          label: "Discapacidad",
                          name: "disability",
                          rules: "required",
                          validationErrors: _vm.errors,
                        },
                        model: {
                          value: _vm.legajo.disability,
                          callback: function ($$v) {
                            _vm.$set(_vm.legajo, "disability", $$v)
                          },
                          expression: "legajo.disability",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c("BaseInput", {
                        attrs: {
                          label: "Apellido*",
                          name: "surname",
                          rules: "required",
                          validationErrors: _vm.errors,
                        },
                        model: {
                          value: _vm.legajo.surname,
                          callback: function ($$v) {
                            _vm.$set(_vm.legajo, "surname", $$v)
                          },
                          expression: "legajo.surname",
                        },
                      }),
                      _c("BaseInput", {
                        attrs: {
                          label: "Documento*",
                          name: "document",
                          rules: "required",
                          validationErrors: _vm.errors,
                        },
                        model: {
                          value: _vm.legajo.document,
                          callback: function ($$v) {
                            _vm.$set(_vm.legajo, "document", $$v)
                          },
                          expression: "legajo.document",
                        },
                      }),
                      _c("BaseInput", {
                        attrs: {
                          label: "CUIL",
                          name: "cuil",
                          rules: "",
                          validationErrors: _vm.errors,
                        },
                        model: {
                          value: _vm.legajo.cuil,
                          callback: function ($$v) {
                            _vm.$set(_vm.legajo, "cuil", $$v)
                          },
                          expression: "legajo.cuil",
                        },
                      }),
                      _c("BaseCombobox", {
                        attrs: {
                          label: "Estado Civil",
                          name: "civil_status",
                          items: _vm.civils_status,
                          "item-text": "name",
                          "item-value": "id",
                          loading: _vm.loading_civils_status,
                          rules: "",
                          validationErrors: _vm.errors,
                        },
                        model: {
                          value: _vm.legajo.civil_status,
                          callback: function ($$v) {
                            _vm.$set(_vm.legajo, "civil_status", $$v)
                          },
                          expression: "legajo.civil_status",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }